import colors, { customThemeExample } from '@theme/colors';

export const halloweenPalette = {
  background: {
    main: '#181818', // deep black
    paper: '#222', // slightly lighter black
    light: '#333',
    secondary: '#ff9800', // orange
    primary: '#ff6f00', // deep orange
    gradient: 'linear-gradient(135deg, #181818 60%, #ff9800 100%)',
  },
  panel: {
    base: '#181818',
    light: 'rgba(255, 152, 0, 0.04)',
    main: '#222',
    dark: '#111',
  },
  drawerNavigation: {
    main: '#181818',
    light: '#222',
    alt: '#ff9800',
  },
  secondary: {
    light: '#ffb74d',
    main: '#ff9800',
    dark: '#c66900',
    alt: '#ff6f00',
  },
  actions: {
    icon: '#ff9800',
  },
  text: {
    main: '#fff',
    disabled: '#ffb74d',
    subdued: '#ffb74d',
    secondary: '#ff9800',
    caption: '#ff9800',
    placeholder: '#ffb74d',
  },
  button: {
    tertiary: '#ff9800',
    tertiaryDark: '#c66900',
    outlinedDark: '#fff',
    outlined: '#181818',
    containedDisabledText: '#ffb74d',
  },
  other: {
    success: '#43a047',
    error: '#d32f2f',
    divider: '#ff9800',
    highlight: '#ff9800',
    bindIncomplete: '#FCCB42',
  },
  info: {
    main: '#ff9800',
    dark: '#c66900',
    hover: '#ffb74d',
    hint: '#fff3e0',
  },
  success: {
    main: '#43a047',
    light: '#66bb6a',
    default: '#43a047',
  },
  error: {
    light: '#d32f2f',
    main: '#d32f2f',
    default: '#d32f2f',
  },
  warning: {
    main: '#ff9800',
    dark: '#c66900',
  },
  primary: {
    main: '#181818',
    dark: '#000',
    light: '#ff9800',
  },
  icon: {
    dark: '#ff9800',
    disabled: '#333',
  },
  accent: {
    secondary: '#ff9800',
    tertiary: '#c66900',
  },
  border: {
    light: '#333',
    main: '#ff9800',
  },
  dataGrid: {
    background: '#181818',
    headerBackground: '#c66900',
    borderLeft: '#ff9800',
    columnHeaderSorted: '#ff9800',
  },
};

export const aprilFoolsPalette = {
  background: {
    main: customThemeExample.BACKGROUND,
    paper: customThemeExample.BACKGROUND_LIGHT,
    light: 'hsl(314 24% 27% / 1)',
    secondary: customThemeExample.SECONDARY,
    primary: customThemeExample.RED_2,

    // used all over in lio so we need it - other themes would probably not be a gradient
    gradient: '#583652',
  },
  panel: {
    base: '#583652',
    light: 'rgba(255, 255, 255, 0.04)',
    main: colors.BLACK_10,
    dark: colors.BLACK_10,
  },
  drawerNavigation: {
    main: customThemeExample.BACKGROUND,
    light: customThemeExample.BACKGROUND,
    alt: customThemeExample.BACKGROUND,
  },
  secondary: {
    light: colors.SUN_YELLOW,
    main: customThemeExample.SECONDARY,
    dark: colors.DARK_SEAFOAM,
    alt: colors.SKY_BLUE,
  },
  actions: {
    icon: customThemeExample.BACKGROUND,
  },
  text: {
    main: colors.WHITE_100,

    disabled: colors.WHITE_60,
    subdued: colors.WHITE_60,

    secondary: colors.WHITE_80,
    caption: colors.WHITE_80,

    placeholder: colors.WHITE_30,
  },
  button: {
    tertiary: customThemeExample.SECONDARY,
    tertiaryDark: customThemeExample.OTHER_COLOR,
    outlinedDark: colors.WHITE_100,
    outlined: customThemeExample.BACKGROUND,
    containedDisabledText: colors.WHITE_60,
  },
  other: {
    success: colors.DARK_SUCCESS,
    error: colors.DARK_ERROR,
    divider: colors.WHITE_30,
    highlight: colors.SEAFOAM,
    bindIncomplete: colors.DARK_BIND_INCOMPLETE,
  },

  info: {
    main: colors.LIGHT_SKY_BLUE,
    dark: colors.SKY_BLUE,
    hover: colors.WHITE_20,
    hint: colors.WHITE_80,
  },
  success: {
    main: colors.DARK_SUCCESS,
    light: colors.DARK_SUCCESS,
    default: colors.DARK_SUCCESS,
  },
  error: {
    light: colors.DARK_ERROR,
    main: colors.DARK_ERROR,
    default: colors.DARK_ERROR,
  },
  warning: {
    main: colors.SUN_YELLOW,
    dark: colors.SUN_YELLOW,
  },
  primary: {
    // this is bad use of colors but needed for ow
    main: customThemeExample.BACKGROUND,
    dark: customThemeExample.PURPLE,
    light: customThemeExample.RED_LIGHT,
  },
  icon: {
    dark: colors.WHITE_100,
    disabled: colors.WHITE_20,
  },
  accent: {
    secondary: colors.CORAL,
    tertiary: customThemeExample.SECONDARY,
  },
  border: {
    light: colors.WHITE_10,
    main: colors.BLACK_25,
  },
  dataGrid: {
    // background: colors.BLACK_10,
    background: '#583652',
    headerBackground: '#55344e',
    borderLeft: customThemeExample.BACKGROUND_LIGHT,
    columnHeaderSorted: customThemeExample.SECONDARY,
  },
};
